import { render, staticRenderFns } from "./TableStatements.vue?vue&type=template&id=0c4ef35f&scoped=true"
import script from "./TableStatements.vue?vue&type=script&lang=js"
export * from "./TableStatements.vue?vue&type=script&lang=js"
import style0 from "./TableStatements.vue?vue&type=style&index=0&id=0c4ef35f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4ef35f",
  null
  
)

export default component.exports